<div [hidden]="!isLoading" class="text-xs-center">
  <i class="fas fa-cog fa-spin fa-3x"></i> <span>{{ message }}</span>
</div>
